<template>
<div>
  <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
  <pt-detection-corpus-structure-form ref="form" class="pt-detection-corpus-structure-form__withData" v-model="formObj"></pt-detection-corpus-structure-form>
</div>

</template>

<script>
import PtDetectionCorpusStructureForm from './index'
export default {
  name: 'pt-detection-corpus-structure-form__withData',
  components: {
    'pt-detection-corpus-structure-form': PtDetectionCorpusStructureForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formObj: {
        contents: [{
          header: '',
          contents: []
        }],
        type: ''
      },
      loading: false,
      resourceName: 'headerimage',
      loadFailed: false
    }
  },
  methods: {
    // formValidate () {
    //   return this.form.validate()
    // }
    // 迭代方法，处理数据
    async recurTest (index, length, data) {
      console.log('ata', data)
      if (data[index].imgURL) {
        console.log('================', data[index].imgURL)
        this.$set(data[index], 'hasIcon', true)
        let createImageParams = {
          name: data[index].header,
          path: data[index].imgURL,
          resourceName: this.resourceName
        }
        try {
          let createdIcon = await this.$store.dispatch('createCorpusHeaderImages', createImageParams)
          console.log(createdIcon)
          this.$set(data[index], 'headerImage', createdIcon.data)
        } catch (err) {
          console.log(err)
          this.$message.error(err)
        }
      } else {
        this.$set(data[index], 'hasIcon', false)
        this.$delete(data[index], 'headerImage')
      }
      console.log('第' + (index) + '次循环')
      if (++index < length) {
        this.recurTest(index, length, data)
      } else {
        let params = {
          type: this.formObj.type,
          name: this.formObj.contents[0].header,
          structure: this.formObj.contents[0]
        }
        let action = 'createCorpusStructure'
        if (this.isEdit) {
          params.id = this.formObj.id
          action = 'updateCorpusStructure'
        }
        console.log('params', params)
        this.$emit('updateLoading', true)
        this.$store.dispatch(action, params).then(data => {
          this.$emit('updateLoading', false)
          this.$message.success(!this.isEdit ? '新建成功!' : '修改成功！')
          this.$router.push({ name: 'detection-corpus-structure-list' })
        }).catch(errorMessage => {
          this.$emit('updateLoading', false)
          console.error(errorMessage)
          this.$message.error(errorMessage)
        })
      }
    },
    addCorpusStructureFunc (params) {
      this.$emit('updateLoading', true)
      this.$store.dispatch('createCorpusStructure', params).then(data => {
        this.$emit('updateLoading', false)
        this.$message.success('新建成功!')
        this.$router.push({ name: 'detection-corpus-structure-list' })
      }).catch(errorMessage => {
        this.$emit('updateLoading', false)
        console.error(errorMessage)
        this.$message.error(errorMessage)
      })
    },
    checkRepeat (params) {
      return this.$store.dispatch('getCorpusStructureByquery', params).then(data => {
        return data
      }).catch(err => {
        return err
      })
    },
    submit () {
      if (!this.formObj.contents[0].header) {
        this.$message.warning('请填写一级名称')
        return
      }
      this.form.validate().then(async formValue => {
        // 二级标题才需要调整
        if (this.formObj.contents[0].contents.length) {
          // 使用递归的方法按顺序执行异步请求
          this.recurTest(0, this.formObj.contents[0].contents.length, this.formObj.contents[0].contents)
        } else {
          let params = {
            type: this.formObj.type,
            name: this.formObj.contents[0].header,
            structure: this.formObj.contents[0]
          }
          console.log('params', params)
          this.$emit('updateLoading', true)
          let checkRes = await this.checkRepeat(params)
          console.log('checkRes', checkRes)
          if (!checkRes.id) {
            this.addCorpusStructureFunc(params)
          } else {
            this.$emit('updateLoading', false)
            this.$confirm(`已存在类型为“${checkRes.type}”,一级标题为“${checkRes.name}”的知识库结构, 是否覆盖原内容?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.addCorpusStructureFunc(params)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消覆盖'
              })
            })
          }
        }
      })
    },
    edit () {
      if (!this.formObj.contents[0].header) {
        this.$message.warning('请填写一级名称')
        return
      }
      this.form.validate().then(formValue => {
        // 二级标题才需要调整
        if (this.formObj.contents[0].contents.length) {
          // 使用递归的方法按顺序执行异步请求
          this.recurTest(0, this.formObj.contents[0].contents.length, this.formObj.contents[0].contents)
        } else {
          let params = {
            id: this.formObj.id,
            type: this.formObj.type,
            name: this.formObj.contents[0].header,
            structure: this.formObj.contents[0]
          }
          console.log('params', params)
          this.$emit('updateLoading', true)

          this.$store.dispatch('updateCorpusStructure', params).then(data => {
            this.$emit('updateLoading', false)
            this.$message.success('编辑成功!')
            this.$router.push({ name: 'detection-corpus-structure-list' })
          }).catch(errorMessage => {
            this.$emit('updateLoading', false)
            console.error(errorMessage)
            this.$message.error(errorMessage)
          })
        }
      })
    },
    async matchRecurTest (index, length, data) {
      if (data[index].headerImage) {
        this.$set(data[index], 'imgURL', data[index].headerImage.path)
      }
      console.log('第' + (index) + '次循环')
      if (++index < length) {
        this.matchRecurTest(index, length, data)
      }
    },
    load () {
      this.loading = true
      this.loadFailed = false
      this.$store.dispatch('getCorpusStructure', this.$route.params.id).then(res => {
        console.log(res.data)
        // 二级标题才需要调整
        if (res.data.structure.contents.length) {
          // 使用递归的方法按顺序执行异步请求
          this.matchRecurTest(0, res.data.structure.contents.length, res.data.structure.contents)
        }
        let targetObj = {
          id: res.data.id, // 必传
          type: res.data.type,
          contents: [res.data.structure]

        }
        this.formObj = targetObj
        this.loading = false
        this.loadFailed = false
      }).catch(errorMessage => {
        this.loading = false
        this.loadFailed = true
        console.error(errorMessage)
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
